module.exports = __webpack_public_path__ + "img/toggle.5ed449a7.svg";